import { useRouter } from 'next/navigation';
import { useNavUtils } from '../../navigationHooks/useNavUtils';
import { CLIENT_PATHS } from '../constants';

export function useClientQuestionsNav() {
  const { generatePath } = useNavUtils();
  const { push } = useRouter();

  const makeNav = (path: string) => {
    return {
      go: () => push(generatePath(path)),
      path: path,
    };
  };

  const personal = makeNav(CLIENT_PATHS.personal);
  const occupation = makeNav(CLIENT_PATHS.occupation);

  return { personal, occupation };
}
